module.exports = __webpack_public_path__ + "static/death_star_assault-aa1aae1315c87f73a4f91aa00d272ce1.gif";